import zhCN from './zh-CN.js';
import zhHK from './zh-HK.js';
import enUS from './en-US.js';
import viVN from './vi-VN.js';
import idID from './id-ID.js';
import msMY from './ms-MY.js';

const rawMessages = {
  'zh-CN': zhCN,
  'zh-HK': zhHK,
  'en-US': enUS,
  'vi-VN': viVN,
  'id-ID': idID,
  'ms-MY': msMY
};

export const messages = rawMessages;

export default messages;
